import React, { useState, useCallback } from 'react';
import CategoryTransactionsDialog from '../Transactions/CategoryTransactionsDialog';

/**
 * Wrapper for CategoryTransactionsDialog that manages its own state.
 * Usage: Place in parent and call openDialog(categoryId, dateRange, title) to show dialog.
 */
const CategoryTransactionsDialogWrapper = React.forwardRef(({
  categories,
  transactions,
  getDateRangeForSelectedMonth,
  formatMonthName
}, ref) => {
  const [open, setOpen] = useState(false);
  const [categoryId, setCategoryId] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [title, setTitle] = useState('');
  const [reportType, setReportType] = useState(null);

  // Expose openDialog to parent via ref
  React.useImperativeHandle(ref, () => ({
    openDialog: (categoryIdArg, dateRangeArg, titleArg, reportTypeArg) => {
      setCategoryId(categoryIdArg);
      setReportType(reportTypeArg || null);
      setDateRange(dateRangeArg);
      setTitle(titleArg || '');
      setOpen(true);
    }
  }));

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <CategoryTransactionsDialog
      open={open}
      onClose={handleClose}
      categoryId={categoryId}
      dateRange={dateRange || getDateRangeForSelectedMonth}
      title={title}
      reportType={reportType}
    />
  );
});

export default CategoryTransactionsDialogWrapper; 
